import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReplacePipe } from '@sdvor/shared/ui';
import { IconModule } from '@spartacus/storefront';
import { PhoneComponent } from './phone.component';

@NgModule({
  declarations: [PhoneComponent],
  imports: [AsyncPipe, ReplacePipe, IconModule],
  exports: [PhoneComponent],
})
export class PhoneComponentModule {}
